import React from 'react';
import { CTABand } from '../../components/CTABand';
export function KidsFinalCTA() {
  return <CTABand headline="Ready to Find the Right Kids Class?" copy="Tell us your child's age and goals — Storm coaches will recommend the right starting class before your first visit. Call 517-220-0621 or fill out the form on this page to schedule a trial." data-id="element-1914" />;
}